/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import AnimatedSvgContainer from './animated-svg-container';
import { INNER_BORDER_RADIUS } from '../constants';
var borderContainerStyles = css({
  display: 'flex',
  position: 'relative',
  padding: "var(--ds-space-025, 2px)",
  width: 'fit-content'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var borderContentStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
  borderRadius: INNER_BORDER_RADIUS,
  flexGrow: 1,
  zIndex: 1 // needs to be more than the svg container at least
});

/**
 * The bulk of this file is originally from
 * https://bitbucket.org/atlassian/barrel/src/master/ui/platform/ui-kit/ai
 * with modifications.
 */
var AIGlowingBorder = function AIGlowingBorder(_ref) {
  var children = _ref.children,
    palette = _ref.palette,
    _ref$isMoving = _ref.isMoving,
    isMoving = _ref$isMoving === void 0 ? true : _ref$isMoving,
    isGlowing = _ref.isGlowing,
    testId = _ref.testId,
    additionalCss = _ref.additionalCss;
  return jsx("div", {
    css: [borderContainerStyles, additionalCss === null || additionalCss === void 0 ? void 0 : additionalCss.container],
    "data-testid": testId
  }, jsx(AnimatedSvgContainer, {
    palette: palette,
    isMoving: isMoving,
    additionalCss: additionalCss === null || additionalCss === void 0 ? void 0 : additionalCss.animatedSvgContainer
  }), isGlowing && jsx(AnimatedSvgContainer, {
    palette: palette,
    isMoving: isMoving,
    isGlowing: true,
    additionalCss: additionalCss === null || additionalCss === void 0 ? void 0 : additionalCss.animatedSvgContainer
  }), jsx("div", {
    css: borderContentStyles
  }, children, " "));
};
export default AIGlowingBorder;